import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

import LoadingButton from '@components/atoms/loadingButton';

export const PurchaseButton = withTheme(styled(LoadingButton)`
  && {
    font-size: ${(props: any) => props.fontSize || '24px'};
    font-weight: 500;
    background: white;
    height: ${(props: any) => props.height || '60px'};
    color: ${(props: any) => props.theme.palette.primary.main};
    :hover {
      opacity: 0.9;
      background-color: white;
    }
    &&.Mui-disabled {
      color: #0000001f;
    }
  }
`);

export const ProductDetailContainer = withTheme(styled(Box)`
  max-width: 1180px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: ${(props: any) => props.padding || '2rem 1rem'};
  ${(props: any) => props.theme.breakpoints.up('lg')} {
    padding: 1rem;
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    padding: 1rem;
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    padding: ${(props: any) => (props.paddingFooter ? props.paddingFooter : '1rem')};
  }
  .text-discount {
    color: #fff;
    opacity: 0.74;
  }
  .ellipsis-2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`);

export const CardDescription = withTheme(styled(Box)`
  padding: 24px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
`);

const ProductDetailStyle = withTheme(styled(Box)`
  padding-bottom: 70px;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, rgba(255, 255, 255, 1) 40%, rgba(255, 255, 255, 0));
  }
  .custom-glance {
    font-family: Lanna;
    font-size: 18px;
  }
  .custom-glance i {
    margin-top: 2px;
    margin-right: 16px;
  }
  .default-glance {
    display: flex;
    margin-bottom: 8px;
    align-items: flex-start;
  }
  .default-glance i {
    font-size: 33px;
    width: 33px;
    color: #00532a;
  }
  .default-glance .subtitle {
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    font-family: Lanna;
  }
  .container {
    max-width: 1180px;
  }
  .course-description-title-desktop {
    ${(props: any) => props.theme.breakpoints.down('lg')} {
      display: none;
    }
  }
  .course-description-title-mobile {
    ${(props: any) => props.theme.breakpoints.up('lg')} {
      display: none;
    }
  }
  .MuiTabs-indicator {
    height: 6px;
    border-radius: 3px;
    background: #00532a;
  }

  ${(props: any) => props.theme.breakpoints.up('lg')} {
    .container {
      margin: 0 auto;
      height: 100%;
      padding: 0rem 1rem;
      position: relative;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .container {
      margin: 0rem auto;
      height: 100%;
      padding: 0 1rem;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    .container {
      max-width: 1150px;
      height: 100%;
    }
  }
`);

export const CardBox = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-flow: wrap;
  padding-top: 30px;
  align-items: center;
  ${theme.breakpoints.up('xs')} {
    padding: 0 0.25rem;
  }
  ${theme.breakpoints.up('md')} {
    flex-direction: column;
    padding: 0 0.75rem;
  }
  ${theme.breakpoints.up('lg')} {
    flex-direction: row;
    padding: 0;
  }
`,
);

export const PreparationContainer = withTheme(styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    grid-template-columns: 1fr 1fr;
    text-align: left;
    grid-row-gap: 22px;
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    grid-row-gap: 22px;
  }
  .img {
    width: 57px;
    height: 57px;
  }
`);

export const NotAllowPurchaseButtonBox = withTheme(styled(Box)`
  background: rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  color: white;
  width: 100%;
  height: ${(props: any) => props.height || '100%'};
  padding: ${(props: any) => props.padding || '14px'};
`);

export default ProductDetailStyle;
